import { render, staticRenderFns } from "./AbilityForm.vue?vue&type=template&id=56cbfb1a&scoped=true&"
import script from "./AbilityForm.vue?vue&type=script&lang=js&"
export * from "./AbilityForm.vue?vue&type=script&lang=js&"
import style0 from "./AbilityForm.vue?vue&type=style&index=0&id=56cbfb1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cbfb1a",
  null
  
)

export default component.exports